import {types} from './types';

const setLoadingAction = (payload) => {
  return {
    type: types.SET_LOADING,
    payload,
  }
}

export {
  setLoadingAction
}